import Vue from 'vue';
import { Decimal } from 'decimal.js';

function format(value: number) {
    return value < 10 ? `0${value}` : `${value}`;
}

/**
 * @param  {number} value 处理前的时间，单位是毫秒
 * @return {string} 参数值
 */
export default Vue.filter('videoDuration', function (value: number) {
    if (!value) {
        return '0:00';
    }

    const time = Number(new Decimal(value).div(1000));
    const minite = Math.floor(time / 60);
    const second = Math.ceil(time % 60);
    return `${minite}:${format(second)}`;
});
